import commaNumber from 'comma-number';
import React from 'react';
import { Link } from 'react-router-dom';
import { MdDeleteOutline, MdEdit } from 'react-icons/md';

const mealTypeColors = {
  Breakfast: {
    bg: 'bg-amber-50',
    text: 'text-amber-700',
    border: 'border-amber-200'
  },
  Lunch: {
    bg: 'bg-emerald-50',
    text: 'text-emerald-700',
    border: 'border-emerald-200'
  },
  Dinner: {
    bg: 'bg-violet-50',
    text: 'text-violet-700',
    border: 'border-violet-200'
  }
};

const RecipeGroupCard = ({ item, handleEdit, onDeleteClick }) => {
  const colors = (type) =>
    mealTypeColors[type] || {
      bg: 'bg-gray-50',
      text: 'text-gray-700',
      border: 'border-gray-200'
    };

  return (
    <div className="flex gap-5 bg-white border border-[#E7E7E9] rounded-[16px] overflow-hidden hover:shadow-md transition-shadow duration-200">
      <Link
        to={`/recipe-groups/${item._id}`}
        className="w-[200px] min-h-[180px] flex-shrink-0"
      >
        <img
          src={item.image}
          alt={item.name}
          className="w-full h-full object-cover"
        />
      </Link>

      <div className="flex-1 py-4 pr-4">
        <div className="flex justify-between items-start">
          <Link to={`/recipe-groups/${item._id}`} className="flex-1">
            <h3 className="text-lg font-semibold capitalize text-[#14151A] hover:text-[#549A9A] transition-colors">
              {item.name}
            </h3>
            {item.description && (
              <p className="text-sm text-[#7C8091] mt-1 line-clamp-2">
                {item.description}
              </p>
            )}
          </Link>

          <div className="flex gap-2 ml-3 flex-shrink-0">
            <button
              onClick={() => handleEdit(item)}
              className="size-9 grid place-items-center rounded-lg border border-[#E7E7E9] hover:bg-[#003333] hover:text-white text-[#5B5B6C] transition-colors"
              title="Edit"
            >
              <MdEdit size={18} />
            </button>
            <button
              onClick={() => onDeleteClick(item)}
              className="size-9 grid place-items-center rounded-lg border border-[#E7E7E9] hover:bg-[#E6483D] hover:text-white text-[#5B5B6C] transition-colors"
              title="Delete"
            >
              <MdDeleteOutline size={18} />
            </button>
          </div>
        </div>

        <div className="flex flex-wrap gap-1.5 mt-3">
          {item.meal_types.map((type) => (
            <span
              key={type}
              className={`text-xs font-medium px-2.5 py-1 rounded-full border ${
                colors(type).bg
              } ${colors(type).text} ${colors(type).border}`}
            >
              {type}
            </span>
          ))}
        </div>

        <div className="flex items-center gap-5 mt-4 text-sm text-[#5B5B6C]">
          <div>
            <span className="text-[#7C8091]">Plan:</span>{' '}
            <span className="font-medium text-[#14151A]">{item.plan}</span>
          </div>
          <div className="w-px h-4 bg-[#E7E7E9]" />
          <div>
            <span className="text-[#7C8091]">Servings:</span>{' '}
            <span className="font-medium text-[#14151A]">{item.servings}</span>
          </div>
          <div className="w-px h-4 bg-[#E7E7E9]" />
          <div>
            <span className="text-[#7C8091]">Recipes:</span>{' '}
            <span className="font-medium text-[#14151A]">{item.recipes.length}</span>
          </div>
          <div className="w-px h-4 bg-[#E7E7E9]" />
          <div>
            <span className="text-[#7C8091]">Price:</span>{' '}
            <span className="font-medium text-[#14151A]">
              {item.price.currency.symbol} {commaNumber(item.price.value)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

const RecipeGroupTable = ({ group, handleEdit, onDeleteClick }) => {
  if (!group || group.length === 0) {
    return (
      <div className="text-center py-16 text-[#7C8091]">
        <p className="text-lg font-medium">No recipe groups found</p>
        <p className="text-sm mt-1">Create a new recipe group to get started</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {group.map((item) => (
        <RecipeGroupCard
          key={item._id}
          item={item}
          handleEdit={handleEdit}
          onDeleteClick={onDeleteClick}
        />
      ))}
    </div>
  );
};

export default RecipeGroupTable;
